import { Input } from "semantic-ui-react";
import React from "react";

export const SearchInput = ({ searchQuery, setSearchQuery }) => {
  const handleChange = (_, { value }) => setSearchQuery(value);
  const handleClear = () => setSearchQuery("");

  const icon = searchQuery
    ? { name: "x", link: true, onClick: handleClear }
    : { name: "search" };

  return (
    <Input
      placeholder="Buscar..."
      icon={icon}
      value={searchQuery}
      onChange={handleChange}
    />
  );
};
